import React from "react";
import "../CSS/AddFuelMeterData.css";
import ErrorPopup from "../../../components/element/ErrorPopup";
import Loader from "../../../components/element/Loader";
import NoDataPlaceholder from "../../../components/element/NoDataPlaceholder";
import { Button } from "@mui/material";

const AddFuelMeterDataTable = ({
  meterData,
  isLoading,
  error,
  onClickSubmit,
}) => {
  if (error) {
    if (error.status === 404) {
      return <NoDataPlaceholder />;
    } else {
      return <ErrorPopup children={error.message}></ErrorPopup>;
    }
  }

  if (isLoading) {
    return <Loader />;
  }

  if (meterData && meterData.length === 0) {
    return <NoDataPlaceholder />;
  }

  return (
    <div className="add-fuel-meter-data-table-parent-container">
      <div className="add-fuel-meter-data-table-container">
        <table className="add-fuel-meter-data-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>ABO Name</th>
              <th>Meter ID</th>
              <th>Fuel Meter Start (gallons)</th>
              <th>Fuel Meter End (gallons)</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {meterData?.map((item, index) => (
              <React.Fragment key={index}>
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item?.fboName}</td>
                  <td>{item?.meterId}</td>
                  <td>{item?.startReading}</td>
                  <td>{item?.endReading}</td>
                  <td>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => onClickSubmit(item)}
                    >
                      Submit Reading
                    </Button>
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AddFuelMeterDataTable;
